@let control = getControl();

<div class="dropdown-control-wrapper">
  <htx-dropdown-field
    [ctrl]="ctrl()"
    [label]="label()"
    [required]="required()"
    [options]="options()"
    [placeholder]="placeholder()"
    [multiple]="multiple()">
  </htx-dropdown-field>

  @if (ctrl().invalid && (ctrl().touched || ctrl().dirty)) {
    <htx-error-field
      [control]="control"
      [errorMessages]="errorMessages()">
    </htx-error-field>
  }
</div>
